import { Grid, withWidth, Typography } from "@material-ui/core";
import Container from "@mui/material/Container";
import React, { useEffect } from "react";
import Benefit1 from "../../../../../assert/images/benefit1.png";
import Benefit2 from "../../../../../assert/images/benefit2.png";
import Benefit3 from "../../../../../assert/images/benefit3.png";
import Benefit4 from "../../../../../assert/images/benefit4.png";
import Benefit5 from "../../../../../assert/images/benefit5.png";
import Benefit6 from "../../../../../assert/images/benefit6.png";
import BenefitBg from "../../../../../assert/images/benefitbg.png";
import researchStyles from "./styles.module.css";

function Benefits(props) {
  let [width, setWidth] = React.useState(window.innerWidth);

  let updateWidthAndHeight = () => {
    setWidth(window.innerWidth);
  };
  useEffect(() => {
    window.addEventListener("resize", updateWidthAndHeight);
    return () => window.removeEventListener("resize", updateWidthAndHeight);
  });
  const benefitItems = [
    {
      icon: Benefit1,
      des: "Budgets optimized – costs constrained & overruns eliminated"
    },
    {
      icon: Benefit4,
      des: "Time to results accelerated – IT keeps pace with the demands of the research"
    },
    {
      icon: Benefit2,
      des: "Sound decisions made – efficiencies & effectiveness of options tapped strategically and executed tactically"
    },
    {
      icon: Benefit3,
      des: "Compliance as a core competence – visible guarantees for controls and constraints as needed"
    },
    {
      icon: Benefit5,
      des: "Usability plus functionality – per use-case enablement allows the focus to remain on the research, not IT nor costs"
    },
    {
      icon: Benefit6,
      des: "Sustainably sourced IT – align IT use with your ESG-metric objectives"
    }
  ];

  return (
    <React.Fragment>
      <section className={researchStyles.benefits}>
        <Container style={{
          position : "relative",
          zIndex : 1
        }} maxWidth="xl">
          <Grid container spacing={3}>
            <Grid item md={12}>
              <h3 className={researchStyles.title}>Benefits</h3>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item >
              <Grid container style={{
                padding: '0px 20px',
                marginTop : '20px'
              }} spacing={3}>
                {benefitItems.map((item, index) => (
                    <Grid item md={6} key={index}>
                      <div className={researchStyles.iconBlock}>
                        <img src={item.icon} alt="benefits" />
                        <p>{item.des}</p>
                      </div>
                    </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        </Container>
        {/*<div className={researchStyles.dotMainConBenefits}>*/}
        {/*  {[...Array(3)].map((x, index) => (*/}
        {/*    <ul key={index} className={researchStyles.backgroundDots}>*/}
        {/*      {[...Array(6)].map((x, index) => (*/}
        {/*        <li key={index} />*/}
        {/*      ))}*/}
        {/*    </ul>*/}
        {/*  ))}*/}
        {/*</div>*/}
      </section>
      {/* <div
        style={{
          backgroundColor: "#fff",
          padding:
            props.width === "xs" || props.width === "sm"
              ? "40px 40px 0px 50px"
              : "80px 40px 0px 50px"
        }}
        ref={props.benefitRef}
      >
        <Grid
          container
          direction="row"
          spacing={props.width === "xs" || props.width === "sm" ? 5 : 10}
          justifyContent="center"
          alignItems="center"
        >
          {props.width === "xs" || props.width === "sm" ? (
            <Grid item xs={3} sm={2} md={2}>
              <img src={BenefitBg} alt="Benefit" width="150%" height="50%" />
            </Grid>
          ) : (
            <></>
          )}
          <Grid
            item
            xs={12}
            sm={12}
            md={10}
            style={{
              paddingLeft:
                props.width === "xs" || props.width === "sm" ? 20 : 60
            }}
          >
            <Grid
              container
              direction="row"
              spacing={10}
              style={{ alignItems: "center" }}
            >
              {benefitItems.map((data) => {
                return (
                  <Grid
                    key={data.id}
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    style={{ paddingTop: 50 }}
                  >
                    <Grid
                      container
                      direction="row"
                      style={{ alignItems: "center" }}
                    >
                      <Grid item xs={2} sm={2} md={2}>
                        <img
                          src={data.icon}
                          alt="Benefit1"
                          width={props.width === "xs" ? "84%" : "50%"}
                          height="86%"
                        />
                      </Grid>
                      <Grid item xs={10} sm={10} md={10}>
                        <Typography
                          style={{
                            fontWeight: 450,
                            paddingLeft: 20,
                            fontSize:
                              props.width === "xs" || props.width === "sm"
                                ? 14
                                : "1.2vw"
                          }}
                        >
                          {data.des}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                );
              })}
            </Grid>
          </Grid>
          {props.width !== "xs" && props.width !== "sm" ? (
            <Grid
              item
              xs={12}
              sm={12}
              md={2}
              style={{ paddingLeft: 50, paddingTop: -50 }}
            >
              <img src={BenefitBg} alt="Benefit" width="150%" height="100%" />
            </Grid>
          ) : (
            <></>
          )}
        </Grid>
      </div> */}
      <div className="indOurMis">
        <div className="iomInner">
          <Grid container direction="row">
            <Grid item md={12}>
              <Typography
                style={{
                  color: "#cedaf8",
                  fontSize:
                    props.width === "xs" || props.width === "sm" ? 32 : "2.3vw",
                  fontWeight: 500
                }}
              >
                OUR MISSION
              </Typography>
            </Grid>
            <Grid item md={12} style={{ marginTop: 10 }}>
              <div
                style={{
                  marginTop: 10,
                  height: props.width === "xs" || props.width === "sm" ? 1 : 1,
                  backgroundColor: "#fff"
                }}
              ></div>
            </Grid>

            <Grid item md={12} style={{ marginTop: 20 }}>
              <Typography
                style={{
                  color: "#f1f1f1",
                  fontSize:
                    props.width === "xs" || props.width === "sm" ? 14 : "1.3vw"
                }}
              >
                Empower researchers with simplified access to cloud workspaces,
                enhancing the versatility and reproducibility of their
                workflows, while accelerating results and reducing costs.
              </Typography>
            </Grid>
            <Grid item md={6}></Grid>
          </Grid>
        </div>
      </div>
    </React.Fragment>
  );
}

export default withWidth()(Benefits);
